import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { Icon } from '../icon';
import { AnimationFixed } from '../animation/Animation';
export const initialSidebarState = {
    position: 'left',
    children: null,
    visible: false,
};
export const SidebarComponent = styled.div `
  position: relative;
  background-color: white;
  width: 100%;
  height: 100%;
  pointer-events: auto;
  ${(props) => (props.closeType === 'back' ? 'padding: 56px 0;' : ``)}
  overflow: scroll;
`;
export const CloseButton = styled.button `
  border: 0px;
  margin: 0px;
  padding: 0px;
  background: none;
  box-shadow: none;
  outline: none;
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 100;
`;
export const BackArrow = styled.button `
  border: 0px;
  margin: 0px;
  padding: 0px;
  background: none;
  box-shadow: none;
  outline: none;
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 100;
`;
export const Sidebar = ({ position, children, visible, handleClose, closeType }) => {
    const animation = position === 'left' ? 'fadeInSlideLeft' : 'fadeInSlideRight';
    const preventBodyScroll = () => {
        if (visible) {
            document.body.style.height = '100%';
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.height = 'auto';
            document.body.style.overflow = 'auto';
        }
    };
    useEffect(() => {
        preventBodyScroll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);
    return ReactDOM.createPortal(React.createElement(Transition, { in: visible, timeout: 300 }, (state) => (React.createElement(AnimationFixed, { name: animation, position: position, className: `animation-${state}`, duration: ".5" },
        React.createElement(SidebarComponent, { closeType: closeType },
            closeType === 'close' && (React.createElement(CloseButton, { type: "button", onClick: handleClose },
                React.createElement(Icon, { name: "icon-light-close", color: "rgba(0, 0, 24, 0.84);", size: "24" }))),
            (closeType === 'back' || closeType === 'backFilter') && (React.createElement(BackArrow, { type: "button", onClick: handleClose },
                React.createElement(Icon, { name: "icon-light-arrow-left", color: "rgba(0, 0, 24, 0.84);", size: "24" }))),
            children)))), document.getElementById('sidebars'));
};
